import React from "react"
import { connect } from "react-redux"
import CampaignPopupPerformanceBySubSourceChart from "./charts/performanceBySubSourceChart"
import CampaignPopupPerformanceBySubSourceList from "./lists/performanceBySubSourceList"
import {
  fetchCampaignPerformanceBySubSourceAsync,
  campaignPopupLoading,
  resetCampaignPopupTable,
} from "../campaignPopupActions"
import { CircularProgress } from "@material-ui/core"
import RequestsService from "../../api/requestsService"

class CampaignPopupPerformanceBySubSources extends React.Component {
  getPerformanceBySubSource = () => {
    RequestsService.cancelRequest("performance-by-sub-source-request")
    this.props.dispatch(campaignPopupLoading())
    this.props.dispatch(
      fetchCampaignPerformanceBySubSourceAsync(
        this.props.campaign,
        this.props.datePickerDates.startDate,
        this.props.datePickerDates.endDate
      )
    )
  }

  componentDidMount() {
    this.getPerformanceBySubSource()
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    if (
      JSON.stringify(prevProps.datePickerDates.startDate) !== JSON.stringify(this.props.datePickerDates.startDate) ||
      JSON.stringify(prevProps.datePickerDates.endDate) !== JSON.stringify(this.props.datePickerDates.endDate)
    ) {
      this.getPerformanceBySubSource()
    }
  }

  componentWillUnmount() {
    this.props.dispatch(resetCampaignPopupTable("performanceBySubSource"))
    RequestsService.cancelRequest("performance-by-sub-source-request")
  }

  render() {
    let loadingIndicator = null
    let subSourcesChartData = []
    let performanceBySubSource = null

    if (this.props.isLoading) {
      loadingIndicator = (
        <div className="campaign-popup-loading d-flex align-items-center justify-content-center">
          <CircularProgress className="loader" size={40} />
        </div>
      )
    } else {
      subSourcesChartData = this.props.performanceBySubSource.slice(
        (this.props.currentPage - 1) * this.props.itemsPerPage,
        this.props.currentPage * this.props.itemsPerPage
      )

      performanceBySubSource = (
        <div className="campaign-popup-performance-by-sub-sources">
          <CampaignPopupPerformanceBySubSourceChart data={subSourcesChartData} />
          <CampaignPopupPerformanceBySubSourceList />
        </div>
      )
    }

    return (
      <>
        {loadingIndicator}
        {performanceBySubSource}
      </>
    )
  }
}

function mapStateToProps(state, ownProps) {
  return {
    campaign: state.campaignPopupV2.campaign,
    datePickerDates: {
      startDate: state.campaignPopupV2.datePickerDates.startDate,
      endDate: state.campaignPopupV2.datePickerDates.endDate,
    },
    isLoading: state.campaignPopupV2.isLoading,
    performanceBySubSource: state.campaignPopupV2.performanceBySubSource.dataForTable,
    itemsPerPage: state.campaignPopupV2.performanceBySubSource.itemsPerPage,
    currentPage: state.campaignPopupV2.performanceBySubSource.currentPage,
  }
}

export default connect(mapStateToProps)(CampaignPopupPerformanceBySubSources)
